<template>
    <div>
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>数据统计</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>用户统计</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-card class="box-card" shadow="hover" style="width: 100%">
                        <div slot="header" class="clearfix">
                            <span>最近7天注册用户数</span>
                        </div>
                        <div style="width:100%;height:300px;" ref="chartsRegister"></div>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="box-card" style="width: 100%" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>最近7天日活</span>
                        </div>
                        <div style="width:100%;height:300px;" ref="chartsLogin"></div>
                    </el-card>
                </el-col>
            </el-row>
        </main>
    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    data() {
        return {
        }
    },
    
    created() {
        
    },
    mounted() {
        let that = this;
        this.$axios.post("/admin/statistics/register")
        .then(function(response) {
            let resp = response.data;
            if(resp.header.status == 0) {
                that.chartsRegister = echarts.init(that.$refs.chartsRegister);
                let optionRegister = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {},
                    xAxis: [
                        {
                            type: 'category',
                            data: resp.data.map(it => it.key),
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            alignTicks: true,
                            axisLabel: {
                                formatter: '{value} 人'
                            }
                        },
                    ],
                    series: [
                        {
                            type: 'bar',
                            tooltip: {
                                valueFormatter: value => value + ' 人'
                            },
                            // prettier-ignore
                            data: resp.data.map(it => it.value),
                        },
                    ]
                };
                // 4.传入数据
                that.chartsRegister.setOption(optionRegister);
            }
        });
        
        this.$axios.post("/admin/statistics/au")
        .then(function(response) {
            let resp = response.data;
            if(resp.header.status == 0) {
                that.chartsLogin = echarts.init(that.$refs.chartsLogin);
                let optionLogin = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {},
                    xAxis: [
                        {
                            type: 'category',
                            data: resp.data.map(it => it.key),
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            alignTicks: true,
                            axisLabel: {
                                formatter: '{value} 人'
                            }
                        },
                    ],
                    series: [
                        {
                            type: 'bar',
                            tooltip: {
                                valueFormatter: value => value + ' 人'
                            },
                            // prettier-ignore
                            data: resp.data.map(it => it.value),
                        },
                    ]
                };
                // 4.传入数据
                that.chartsLogin.setOption(optionLogin);
            }
        });
    },
}
</script>
